@if (homeType === HomeType.simple) {
  <app-home-simple [class.content-below]="strips?.length"></app-home-simple>
}
@if (homeType === HomeType.meny) {
  <app-home-meny></app-home-meny>
}
@if (homeType === HomeType.fancy) {
  <app-home-fancy></app-home-fancy>
}

@defer (hydrate on idle) {
  @if (strips?.length) {
    <app-strip-container [strips]="strips"></app-strip-container>
  }
}
